<template lang="pug">
#customer_protection_statement
  custom-header
  section.container.i_mb_10
    .row.i_mt_14.i_mt_md_10
      .col-12.text-center
        h2.i_h2_title {{ infoSecurity.area01_Title }}
    .row.i_mt_10
      .col-12
        pre {{ infoSecurity.area01_Content }}
  .container-fluid.bg_blue
    section.container.items.i_pt_12
      .row
        .col-md-6.i_mb_9.i_mb_md_7.i_mb_sm_8(
          v-for="(item, index) in itemList",
          :key="index"
        )
          item(:item="item")
  custom-footer
</template>

<script>
import Item from "@/components/about_us/social_responsibility/Item";
import CustomHeader from "@/components/common/Header";
import CustomFooter from "@/components/common/Footer";
import { getInfoSecurity } from "@/json/menu";

export default {
  name: "CustomerProtectionStatement",
  metaInfo() {
    return {
      title: this.infoSecurity.SEO_Title,
      meta: [{ name: "description", content: this.infoSecurity.SEO_Description }],
    };
  },
  components: {
    "custom-header": CustomHeader,
    "custom-footer": CustomFooter,
    item: Item,
  },
  data() {
    return {
      infoSecurity: {},
      itemList: [],
    };
  },
  created() {
    this.getInfoSecurity();
  },
  methods: {
    getInfoSecurity() {
      getInfoSecurity().then((response) => {
        this.infoSecurity = response.data;

        this.itemList = [];
        for (let index in this.infoSecurity.area02_ItemList) {
          let temp = this.infoSecurity.area02_ItemList[index];
          let item = {
            title: temp.ItemName,
            content: temp.ItemContent,
            img: temp.ItemIcon,
            pageUrl: temp.ItemURL,
          };
          this.itemList.push(item);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h2.title {
  @include font(24px, $color_blue_ci, normal);
}

pre {
  white-space: pre-wrap;
}

@media (max-width: 991px) {
  h2.title {
    font-size: 18px;
  }
}

@media (max-width: 767px) {
  h2.title {
    font-size: 28px;
  }
}

@media (max-width: 575px) {
  h2.title {
    font-size: 4.8vw;
  }
}
</style>
